<template>
    <div class="vm-wechat-open-app">
        <img v-if="is_need_img" :src="src" alt="">
        <!-- <a href="/app?test_id=123" v-if="session_user && session_user.user_id == '179f19102e7111e8bf4d52540025c377'">打开/app</a>
        <span @click="open_test" v-if="session_user && session_user.user_id == '179f19102e7111e8bf4d52540025c377'">直接</span> -->
         <wx-open-launch-app
            id="launch-btn"
            class="wx-open-launch-app"
            appid="wx14c145629e32cc44"
            @error="error"
            @launch="launch"
            :extinfo="extinfo">
            <!-- <script type="text/wxtag-template">
                <style>
                    .btn{
                        padding: 0;
                        font: inherit;
                        color: inherit;
                        cursor: pointer;
                        background: none;
                        border: none;
                        outline: none;
                        -webkit-appearance: none;
                        -moz-appearance: none;
                        appearance: none;
                        font-size: 15px;
                        font-weight: 500;
                        line-height: 36px;
                        text-align: center;
                        color: rgb(255, 255, 255);
                        background: rgba(148,108,230,1);
                        border: none;
                        border-radius: 18px;
                        width: 105px;
                        box-shadow: rgb(18 18 18 / 25%) 0px 2px 5px;
                        transition: transform 0.3s ease 0.3s;
                    }
                </style>
                <button class="btn">App内查看</button>
            </script> -->
            <script type="text/wxtag-template">
                <style>
                * {
                    -webkit-tap-highlight-color: transparent !important;
                }
                * {
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                }
                </style>
                <div class="template"></div>
            </script>
        </wx-open-launch-app>
    </div>
</template>

<script>
//参考 https://juejin.cn/post/7034024871587741726
import {mapState} from 'vuex'
export default {
  props: {
      is_need_img: {
        default() {
            return true;
        }
    }
  },
  data() {
    return {
        src:`${this.GL.PIC_HOST}/static/img/buttion-openinapp.jpg`
      //   n: this.browser_size == "small" ? 2 : 3
    };
  },
  watch:{
      $route(){
        this.init()
      }
  },
  computed:{
      ...mapState('app',['session_user']),
      extinfo(){
        let url = location.href;
        let type = '1';
        let r = this.$route;
        if(r.name == 'index' || r.name == 'feed'){
            url = '/feed'
            type = '2'
        }
        if(r.name == 'explore'){
            url = '/explore'
            type = '2'
        }
        if(r.name == 'message'){
            url = '/message'
            type = '2'
        }
        if(r.name == 'dashboardStats'){
            url = '/dashboard'
            type = '2'
        }
        return JSON.stringify({'url': url,'type':type})
      }
  },
  mounted() {
      this.init()
  },
  methods: {
    open_test(){
        location.href="afd://app/openapp?url=dashboard&type=2"
    },
    init(){
        this.$wx_jssdk_ready(location.href,() => {})
    },
    error(e) {
        console.log(JSON.stringify(e), '跳转失败')
        console.log(e)
        console.log(e.detail)
        // window.wx_event_error2 = e
        if(this.$route.name == 'testxxx'){
          this.$notify({
              title: JSON.stringify(e),
              group: "error",
          });
          return false;
        }
        location.href = this.GL.ENV.yingyongbao + '&android_schema=1&ios_schema=2';
    },
    launch(e){
        console.log(JSON.stringify(e), '跳转成功')
    }
  }
};
</script>

<style lang="stylus" scoped>
.vm-wechat-open-app{
    width:62px;
    height:26px;
    position:relative;
    .wx-open-launch-app{
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 20;
        overflow: hidden;
    }
    // position: fixed;
    // top: auto;
    // bottom: 0px;
    // left: 50%;
    // z-index: 100;
    // transform: translate(-50%, -75px);
}
</style>
